$(document).on('ready', function() {

  $('.js-bis-button').on('click', function() {
    $('.js-size-label').html('<span style="color:#b41c26; font-style:italic; font-weight:600; font-family: \'Gill Sans\',\'Gill Sans MT\',Calibri,sans-serif;">Please Select a Size</span>');
    return false;
  });

  $('form[action="/cart/add"]').on('submit', function(r) {

    let variantId = $('#variant_select').val();

    // Check a selection has been made
    if(!variantId) {
        $('.js-size-label').html('<span style="color:#b41c26; font-style:italic; font-weight:600; font-family: \'Gill Sans\',\'Gill Sans MT\',Calibri,sans-serif;">Please Select a Size</span>');
        return false;
    }

    // Disable button
    var btn = $('input[type=submit]', this),
        feedback = $('.response').hide();

    btn.prop('disabled', true).css('opacity', '0.2');

    $.post('/cart/add.js', $(this).serialize(), function(r) {
      feedback.addClass('success').html('Added to bag. <a href="/cart">Click here to view bag</a>');

      // Update cart count from 0 to 1, ignore others as full minibasket wont be available anyway

      // $(".mini-cart").fadeIn().delay(8000).fadeOut();
      $(".js-slide-cart").removeClass('tw-hidden');
      $('html, body').css({ 'overflow': 'hidden', 'height': '100%' });
      $(".empty-cart").hide();
      $("#cart-updater").show();
      $("#cart-items").hide();
      $("html, body").animate({ scrollTop: 0 }, "slow");

      if($('.js-dry-bag').length) {
        $.post('/cart/add.js', { id: 29098581885012, quantity:1 }, function(r) {
        	// Dry bag added
          	$('#cart-updater .mini-cart-item-details').append('<p>With FREE Dry Bag</p>');
        }, 'json');
      }

      $.get('/cart.js', function(r) {

        window.dispatchEvent(new CustomEvent('cart', { detail: { cart: r }, bubbles: true }));
        window.dispatchEvent(new CustomEvent('item-count', { detail: r.item_count, bubbles: true }));

        $('.js-cart-count-number').html(r.item_count);
        $('.js-cart-total').html('£ ' + (r.total_price / 100).toFixed(2));
        if(r.item_count > 0) {
          $('.js-bag-full').removeClass('tw-hidden');
          $('.js-bag-empty').addClass('tw-hidden');
          $('.js-cart-count-number').addClass('tw-text-white').removeClass('tw-text-black');
        } else {
          $('.js-bag-full').addClass('tw-hidden');
          $('.js-bag-empty').removeClass('tw-hidden');
          $('.js-cart-count-number').removeClass('tw-text-white').addClass('tw-text-black');
        }
      }, 'json')

    }, 'json')
      .fail(function(r) {
        if(r.responseJSON.message == 'Parameter Missing or Invalid') {
          $('.js-size-label').html('<span style="color:#b41c26; font-style:italic; font-weight:600; font-family: \'Gill Sans\',\'Gill Sans MT\',Calibri,sans-serif;">Please Select a Size</span>');

        } else {
          feedback.addClass('error').html(r.responseJSON.description);
        }
      })
      .always(function() {
        btn.prop('disabled', false).css('opacity', '1');
        feedback.fadeIn('slow').delay(3000).fadeOut('slow');
      });

  	return false;
  })

  $("#more-fit-btn").click(function() {
    $("#fit-content").slideToggle('slow');
  });

  $('.yotpo--stars').click(function() {

    if ($(window).width() >= 770) {
	  // Scroll to last image on desktop as panel is fixed
      $('.accordion.reviews').addClass('active').next().addClass('show');
      $('html,body').scrollTop($('.product-image:last-child').offset().top);
    } else {
      $('.accordion.reviews').trigger('click');
    }
  });

  /* Same Day Delivery Countdown */
  $(function() {
    $('#countdown').countdown({until: getTarget(), onExpiry: restartCountdown, layout: '{d<}{dn}d {d>}{h<}{hn}h {h>}{m<}{mn}m {m>}{s<}{sn}s{s>}'});
  });

  function getTarget() {
    var target = new Date();

    // Bank holidays etc: don't show timer
    var exceptionsString = $('.js-countdown-exceptions').data('exceptions');
    var exceptions = [];

    if(exceptionsString) {
      exceptions = exceptionsString.split(',');
    }

    var stringDate = target.toISOString().split('T')[0];

    if(exceptions.indexOf(stringDate) !== -1) {
      $(".next-day-delivery").hide();
      $(".js-delivery-countdown").addClass('tw-hidden');
      return target;
    }

    // Sunday, 10am - 2pm | Saturday, off | Monday - Friday, show til 4pm
    if (target.getHours() < 15 && target.getDay() != 6 && target.getDay() != 0) {
      target.setHours(15, 0, 0, 0);
      if(target.getDay() == 5) {
        $('.js-countdown-text').text('Left for Monday delivery');
      }
    } else {
      $(".next-day-delivery").hide();
      $(".js-delivery-countdown").addClass('tw-hidden');
    }
    return target;
  }

  function restartCountdown() {
    $('#countdown').countdown('change', {until: getTarget()});
  }

  //hide countdown on Friday(5) Saturday(6) and Sunday (0)
  var d = new Date();
  if(d.getDay()=='5')
    //$('.next-day-delivery').hide();
    if(d.getDay()=='6')
      $('.next-day-delivery').hide();
  if(d.getDay()=='0')
    $('.next-day-delivery').hide();


  /* Product Info Accordian — Toggle between adding and removing the "active" and "show" classes when the user clicks on one of the "Section" buttons. The "active" class is used to add a background color to the current button when its belonging panel is open. The "show" class is used to open the specific accordion panel */
  var acc = document.getElementsByClassName("js-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
      this.classList.toggle("active");
      this.nextElementSibling.classList.toggle("show");
    }
  }

  $('.product-image img').click(function(){
    var img_url = $(this).data('fullsize'),
    	img_index = $(this).data('index'),
		totalImages = $('.product-image').length;

    $('#fullscreen-image img').attr('src', '');
    $('#fullscreen-image img').attr('src', img_url);

    $('#fullscreen-image').fadeIn();

    $('#fullscreen-image .close').click(function(){
      $('#fullscreen-image').fadeOut();
    });

    $('.navigate.right').click(function(){
      console.log(totalImages);
      if (img_index != totalImages) {
        img_index = img_index + 1
        img_url = $('.product-image img[data-index="' + img_index +'"]').data('fullsize');
        $('#fullscreen-image img').attr('src', img_url);
      }
    });

    $('.navigate.left').click(function(){
      if (img_index != 1) {
        img_index = img_index - 1
        img_url = $('.product-image img[data-index="' + img_index +'"]').data('fullsize');
        $('#fullscreen-image img').attr('src', img_url);
      }

    });
  });

});

jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});
